import React from "react";
import { Footer, Header } from "../Home/components";
import { Body } from "./components";
export default function View() {
  return (
    <div>
      <Header page="artist" />
      <Body />
      <Footer page="artist" />
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/pages/Artist/view.jsx